import { Modal } from '@facephi/ui-react';
import styled from 'styled-components/macro';

export const ModalAssignServiceStyles = styled(Modal)`
  width: 45rem;
`;
